<template>
  <div id="print-report">
    <vs-card>
      <div class="grid w-full"
           style="grid-template-columns: 114px 134px 134px 1fr; font-size: 14px; grid-column-gap: 14px;">
        <div class="flex items-center">대상기간</div>
        <div class="flex items-center">
          <p v-if="isPrint" class="print-input">{{ year }}</p>
          <search-nav-item-select
            class="search-item" v-else v-model="year" :list="getYearList" @change="loadListBoard"/>
          <p class="ml-2 mr-2 text-center">년</p>
        </div>
        <div class="flex items-center">
          <p v-if="isPrint" class="print-input">{{ month }}</p>
          <search-nav-item-select v-else v-model="month" :list="getMonthList" @change="loadListBoard"/>
          <p class="ml-2 text-center">월</p>
        </div>
      </div>
    </vs-card>

    <div class="flex w-full items-center mb-4">
      <vs-button class="ml-auto" type="border" color="secondary" @click="()=> showExcelDownload = true">{{$t('button.Excel 다운로드')}}</vs-button>
    </div>

    <div class="grid" style="grid-template-columns: 200px repeat(16, 1fr) repeat(2, 100px)">
      <div class="th" style="grid-row: span 2;">직종</div>
      <div class="th" style="grid-column: span 2;">일반건강진단</div>
      <div class="th" style="grid-column: span 7;">배치전 건강진단</div>
      <div class="th" style="grid-column: span 7;">특수건강진단</div>
      <div class="th" style="grid-row: span 2;">소계(월)</div>
      <div class="th" style="grid-row: span 2;">누계(년)</div>

      <div class="th">C2</div>
      <div class="th">D2</div>
      <div class="th">C1</div>
      <div class="th">C2</div>
      <div class="th">CN</div>
      <div class="th">D1</div>
      <div class="th">D2</div>
      <div class="th">DN</div>
      <div class="th">R</div>
      <div class="th">C1</div>
      <div class="th">C2</div>
      <div class="th">CN</div>
      <div class="th">D1</div>
      <div class="th">D2</div>
      <div class="th">DN</div>
      <div class="th">R</div>

      <template v-for="(row, rowIdx) of selectedForm">
        <template v-for="(item, itemIdx) of row">
          <div :class="[itemIdx < 1 || rowIdx === selectedForm.length - 1 ? 'th' : 'td']" :key="`${rowIdx}_${itemIdx}`">{{ item }}</div>
        </template>
      </template>
    </div>

    <popup-excel-download
      v-model="showExcelDownload"
      :list="getExcelList"
      :title="getExcelFileName"
      :show-header="false"
    />
  </div>
</template>

<script>
import FieldSelectModule from '@/views/modules/FieldSelectModule'
import PopupPlanProject from '@/views/project/popup/PopupPlanProject'
import DateSelector from '@/components/selector/DateSelector'
import PopupProjectSetting from '@/views/project/PopupProjectSetting'
import MemberSelector from '@/components/selector/MemberSelector'
import CompanySelector from '@/components/selector/CompanySelector'
import FileUploader from '@/components/FileUploader'
import FileUploadModule from '@/views/modules/FileUploadModule'
import SearchNavItemSelect from "@/components/nav/SearchNavItemSelect.vue";
import PopupExcelDownload from "@/popup/PopupExcelDownload.vue";


export default {
  name: "Viewer452",
  components: {
    PopupExcelDownload,
    SearchNavItemSelect,
    FieldSelectModule,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
    FileUploadModule
  },
  props: {
    tab: Object,
    board: Object,
    value: Object,
    header: Object,
  },
  computed: {
    myInfo() {
      return this.$store.state.auth.userInfo
    },
    projectId() {
      return parseInt(this.$route.params.proj_id) || 0;
    },
    postId() {
      return parseInt(this.$route.params.postId);
    },
    boardId() {
      return this.$route.params.boardId;
    },
    getSelectedDate() {
      const monthStr = String(this.month).padStart(2, '0');
      return `${this.year}-${monthStr}`;
    },
    getYearList() {
      const currentYear = new Date().getFullYear();
      const startYear = currentYear + 1 - 49;
      const endYear = currentYear + 1;
      const yearList = [];
      for (let i = startYear; i <= endYear; i++) {
        yearList.push({text: `${i}`, value: i})
      }
      return yearList.reverse();
    },
    getMonthList() {
      const monthList = [];
      for (let i = 0; i < 12; i++) {
        const month = i + 1;
        monthList.push({text: `${month}월`, value: month});
      }
      return monthList;
    },
    getExcelList() {
      const result = [
        {
          '직종': '',
          '일반.C2': '일반건강진단',
          '일반.D2': '',
          '배치전.C1': '배치전 건강진단',
          '배치전.C2': '',
          '배치전.CN': '',
          '배치전.D1': '',
          '배치전.D2': '',
          '배치전.DN': '',
          '배치전.R': '',
          '특수.C1': '특수건강진단',
          '특수.C2': '',
          '특수.CN': '',
          '특수.D1': '',
          '특수.D2': '',
          '특수.DN': '',
          '특수.R': '',
          '소계(월)': '',
          '누계(년)': '',
        },
        {
          '직종': '직종',
          '일반.C2': 'C2',
          '일반.D2': 'D2',
          '배치전.C1': 'C1',
          '배치전.C2': 'C2',
          '배치전.CN': 'CN',
          '배치전.D1': 'D1',
          '배치전.D2': 'D2',
          '배치전.DN': 'DN',
          '배치전.R': 'R',
          '특수.C1': 'C1',
          '특수.C2': 'C2',
          '특수.CN': 'CN',
          '특수.D1': 'D1',
          '특수.D2': 'D2',
          '특수.DN': 'DN',
          '특수.R': 'R',
          '소계(월)': '소계(월)',
          '누계(년)': '누계(년)',
        }
      ];

      if (this.selectedForm) {
        for (const row of this.selectedForm) {
          result.push({
            '직종': row[0],
            '일반.C2': row[1],
            '일반.D2': row[2],
            '배치전.C1': row[3],
            '배치전.C2': row[4],
            '배치전.CN': row[5],
            '배치전.D1': row[6],
            '배치전.D2': row[7],
            '배치전.DN': row[8],
            '배치전.R': row[9],
            '특수.C1': row[10],
            '특수.C2': row[11],
            '특수.CN': row[12],
            '특수.D1': row[13],
            '특수.D2': row[14],
            '특수.DN': row[15],
            '특수.R': row[16],
            '소계(월)': row[17],
            '누계(년)': row[18],
          })
        }
      }

      return result;
    },
    getExcelFileName() {
      let title = '유소견자 건강 상담 실적 통계';
      title += `_${this.year}년`;
      title += `_${this.month}월`;
      return title;
    },
    getSelectedFieldName() {
      if (parseInt(this.selectedFieldId) === 0) {
        return '전체 사업장';
      }

      const fieldData = this.fieldData[this.selectedFieldId];
      if (!fieldData) {
        return '';
      }

      const stdInfo = fieldData.stdInfo;
      if (stdInfo) {
        return stdInfo.field_name;
      } else {
        return '';
      }
    },
  },
  watch: {
    year: {
      handler() {
        this.loadListBoard();
      }
    },
    month: {
      handler() {
        this.loadListBoard();
      }
    },
    selectedCompanyId: {
      handler() {
        this.loadListBoard();
      }
    },
    selectedFieldId: {
      handler() {
        console.log('selectedFieldId', this.selectedFieldId);
      }
    },
  },
  data() {
    return {
      showExcelDownload: false,
      isPrint: false,
      oldForm: {},
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      companyList: [],
      cachedData: undefined,
      selectedCompanyId: 0,
      fieldList: [],      // 선택된 업체와 연관된 현장 ID
      selectedFieldId: 0, // 선택된 현장 ID
      selectedForm: [],
      fieldData: {},
      // API에서 불러온 통계 데이터
      classifications: ['공무원', '공무직', '임기제', '기간제', '기능직', '근로자', '공공근로', '노인일자리', '장애인일자리', '지역공동체', '합계'],
      // checkTypes: ['일반', '배치전', '배치후', '특수'],
      checkTypes: ['일반', '배치전', '특수'],
      definitions: {
        '일반': ['', 'C2', 'D2'],
        '배치전': ['C1', 'C2', 'CN', 'D1', 'D2', 'DN', 'R'],
        '배치후': ['C1', 'C2', 'CN', 'D1', 'D2', 'DN', 'R'],
        '특수': ['C1', 'C2', 'CN', 'D1', 'D2', 'DN', 'R', '소계', '누계'],
      },

      form: {
        total: {},
        stdInfo: {},
        fileList: [],
        totalB: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        inputB: [
          {label: '안전·보건관리자 임금 등', value1: 0, value2: 0, value3: 0, value4: '0.00'},
          {label: '안전시설비 등', value1: 0, value2: 0, value3: 0, value4: '0.00'},
          {label: '보호구 등', value1: 0, value2: 0, value3: 0, value4: '0.00'},
          {label: '안전보건진단비 등', value1: 0, value2: 0, value3: 0, value4: '0.00'},
          {label: '안전보건교육비 등', value1: 0, value2: 0, value3: 0, value4: '0.00'},
          {label: '근로자 건강장해예방비 등', value1: 0, value2: 0, value3: 0, value4: '0.00'},
          {label: '건설재해예방전문지도기관 기술지도비', value1: 0, value2: 0, value3: 0, value4: '0.00'},
          {label: '본사 전담조직 근로자 임금 등', value1: 0, value2: 0, value3: 0, value4: '0.00'},
          {label: '위험성평가 등에 따른 소요비용', value1: 0, value2: 0, value3: 0, value4: '0.00'},
        ],
        inputC: [
          {label: '안전관리계획서 작성비', value1: 0, value2: 0, value3: 0, value4: '0.00'},
          {label: '현장안전점검비', value1: 0, value2: 0, value3: 0, value4: '0.00'},
          {label: '공사장 주변 안전관리 사용비', value1: 0, value2: 0, value3: 0, value4: '0.00'},
          {label: '통행안전 및 교통소통 대책비', value1: 0, value2: 0, value3: 0, value4: '0.00'},
          {label: '공사 중 구조적 안전성 확보비용', value1: 0, value2: 0, value3: 0, value4: '0.00'},
          {label: '기타(안전관리비)', value1: 0, value2: 0, value3: 0, value4: '0.00'},
        ],
      }
    }
  },
  created() {
    this.initBreadcrumb();
  },
  mounted() {
    this.loadListBoard();
  },
  methods: {

    initBreadcrumb () {
      if (this.boardId === '_361') {
        this.$store.commit('menu/UPDATE_PAGE_LIST', [
          {title: 'Home'}, {title: '안전·보건관리 현황'}, {
            title: '유소견자 건강 상담 실적 통계',
            note: '「산업안전보건법」제39조제1항(보건조치), 「산업안전보건기준에 관한 규칙」제657조(유해요인 조사)',
            active: true
          }
        ])
      } else {
        this.$store.commit('menu/UPDATE_PAGE_LIST', [
          {title: 'Home'}, {title: '안전·보건관리 현황'}, {
            title: '유소견자 건강 상담 실적 통계',
            active: true
          }
        ])
      }
    },
    async loadListBoard() {
      // 게시글 불러온다
      const targetYear = this.year
      const targetMonth = this.month

      let data = {};
      if (typeof this.cachedData !== 'undefined' && typeof this.cachedData[this.getSelectedDate] !== 'undefined') {
        // 캐싱된 데이터가 있으면, 불러서 쓰고
        data = this.cachedData;
      } else {
        this.cachedData = {};

        // 없으면 API를 호출한다
        data = await this.$store.dispatch('board/LOAD_452_SUMMARY', {
          projectId: this.projectId,
          targetYear,
          targetMonth,
        });

        // 캐시에 저장
        const dataKeys = Object.keys(data);
        for (const key of dataKeys) {
          this.cachedData[key] = data[key];
        }
      }

      this.parseData();
    },
    // 통계 데이터를 테이블 형식에 맞게 변환한다
    parseData() {
      this.selectedForm = [];

      for (const classification of this.classifications) {
        const rowData = [];
        rowData.push(classification);

        for (const checkType of this.checkTypes) {
          const definitions = this.definitions[checkType];
          for (const definition of definitions) {
            if (definition) {
              if (definition === '소계') {
                rowData.push(this.getStatisticsMonthlySumData(classification));
              } else if (definition === '누계') {
                rowData.push(this.getStatisticsYearlySumData(classification));
              } else {
                rowData.push(this.getStatisticsData(classification, checkType, definition));
              }
            }
          }
        }

        this.selectedForm.push(rowData);
      }
    },
    getStatisticsData(classification, type, definition) {
      const selectedDate = this.getSelectedDate;
      // 선택된 날짜 데이터가 있는지 확인한다
      if (this.cachedData && this.cachedData[selectedDate]) {
        return this.cachedData[selectedDate][`${classification}.${type}.${definition}`];
      } else {
        // 해당 날짜에 데이터가 없으면, 0을 반환한다
        return 0;
      }
    },
    getStatisticsMonthlySumData(classification) {
      const selectedDate = this.getSelectedDate;
      const type = '누계';
      // 선택된 날짜 데이터가 있는지 확인한다
      if (this.cachedData && this.cachedData[selectedDate]) {
        return this.cachedData[selectedDate][`${classification}.${type}`];
      } else {
        // 해당 날짜에 데이터가 없으면, 0을 반환한다
        return 0;
      }
    },
    getStatisticsYearlySumData(classification) {
      const selectedDate = this.year;
      const type = '누계';
      // 선택된 날짜 데이터가 있는지 확인한다
      if (this.cachedData && this.cachedData[selectedDate]) {
        return this.cachedData[selectedDate][`${classification}.${type}`];
      } else {
        // 해당 날짜에 데이터가 없으면, 0을 반환한다
        return 0;
      }
    },
    printLandscape() {
      this.print("@media print {@page { size: a3 landscape; }}");
    },
    printPortrait() {
      this.print("@media print {@page { size: a3 portrait; }}");
    },
    print(css) {
      // 프린트
      this.isPrint = true;

      setTimeout(() => {
        const printTextarea = document.getElementsByClassName("print-textarea");
        for (let i = 0; i < printTextarea.length; i++) {
          const pt_r = printTextarea[i].innerHTML
            .trimStart()
            .trimEnd()
            .replace(/\r\n/gi, "<br>")
            .replace(/\\n/gi, "<br>")
            .replace(/\n/gi, "<br>");

          document.getElementsByClassName("print-textarea")[i].innerHTML = pt_r;
        }

        const hidePrintTitleEl = document.getElementById("hidePrintTitle");
        const hidePrintTitle = hidePrintTitleEl && hidePrintTitleEl.value === "true"

        const g_label = document.getElementById("print-label") ? document.getElementById("print-label").innerHTML : '';
        const g_oBeforeBody = document.getElementById("print-report").innerHTML;

        const beforeApprovalEl = document.getElementById("print-approval");
        const g_oBeforeApproval = beforeApprovalEl ? beforeApprovalEl.innerHTML : '';

        // 프린트를 보이는 그대로 나오기위한 셋팅
        window.onbeforeprint = function () {
          document.body.style.backgroundColor = "#fff";
          document.body.innerHTML = ''
          if (g_label && isPrint && !hidePrintTitle) {
            document.body.innerHTML += `${g_label}<br>`
          }
          document.body.innerHTML += `${g_oBeforeBody}<br>${g_oBeforeApproval}`;
        };

        const head = document.head || document.getElementsByTagName("head")[0],
          style = document.createElement("style");

        style.type = "text/css";
        style.media = "print";

        if (style.styleSheet) {
          style.styleSheet.cssText = css;
        } else {
          style.appendChild(document.createTextNode(css));
        }

        head.appendChild(style);

        window.print();
        location.reload();
      }, 300);
    },
    onClickPrint() {
      const customAlert = new CustomEvent("customAlert", {
        detail: {
          title: "레이아웃 선택",
          messageIcon: "AlertCircleIcon",
          message: "인쇄 방향을 선택해 주세요.",
          useConfirm: true,
          confirmBtn: "세로 방향",
          cancelBtn: "가로 방향",
          confirmFunction: () => this.printPortrait(),
          cancelFunction: () => this.printLandscape(),
          size: "small",
          btnPosition: "center",
          confirmBtnStyle: {
            type: "border",
            icon: {type: "image", name: "icon-print-layout-vertical.svg"},
            style: "",
          },
          cancelBtnStyle: {
            type: "border",
            icon: {type: "image", name: "icon-print-layout-horizontal.svg"},
            style: "",
          },
        },
      });
      window.dispatchEvent(customAlert);
    },
    getContent(data) {
      if (data.post_content) {
        const content = JSON.parse(data.post_content)
        return content.body
      }
    },
    getHeader(data) {
      if (data.post_content) {
        const content = JSON.parse(data.post_content)
        return content.header
      }
    },
    comma(str) {
      return `${str}`.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },

    removeComma(str) {
      if (str) {
        const noneComma = `${str}`.replaceAll(',', '')
        return `${Number(noneComma)}`
      }
      return '0'
    },
    percentage(a, b) {
      // A를 B로 나눈 결과를 구합니다.
      const result = b !== 0 ? (a / b) * 100 : 0;
      // 소수점 2자리까지 반올림합니다.
      const roundedResult = Math.round(result * 100) / 100;
      // 문자열로 변환합니다.
      const resultString = roundedResult.toString();
      // 소수점이 없는 경우 '.00'을 덧붙입니다.
      if (!resultString.includes('.')) {
        return `${resultString}.00`;
      }
      // 소수점이 하나만 있는 경우 '0'을 덧붙입니다.
      if (resultString.split('.')[1].length === 1) {
        return `${resultString}0`;
      }
      // 소수점이 둘 이상인 경우 그대로 반환합니다.
      return resultString;
    }
  },
}
</script>

<style scoped>

.th {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 54px;
  background-color: #f9f9f9;
  outline: 1px solid #cdcdcd;
  text-align: center;
}
.td {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;
  padding: 7px;
  outline: 1px solid #cdcdcd;
}
</style>
